const AVERAGE_READING_WORDS_PER_MINUTE = 200;

type ChapterReadingStats = {
  avg_paragraph_word_length: number;
  num_paragraphs: number;
};

export function estimateReadingTimeMinutes(
  chapters: ReadonlyArray<ChapterReadingStats>,
) {
  const estimatedWordCount = chapters.reduce(
    (total, chapter) =>
      total + chapter.avg_paragraph_word_length * chapter.num_paragraphs,
    0,
  );

  if (estimatedWordCount <= 0) return null;
  return Math.max(
    1,
    Math.ceil(estimatedWordCount / AVERAGE_READING_WORDS_PER_MINUTE),
  );
}
